import { useRef } from 'react';

/*

The useScope hook is an "always up to date" object that changes but never triggers re-render in hooks.
This hook is perfect for callbacks and values that we don't care about most of the time.

For example:

  // always up to date
  const scope = useScope({
    id: props.id,
    value: props.value,
    onClick: props.onClick,
  });

  const btn = useMemo(() => {
    const onClick = () => {
      // on click always use the latest callback, id and value
      scope.onClick(scope.id, scope.value);
    };
    return <button onClick={onClick}>Click me</button>
  }, [scope]); // scope included just for lint, it will never change

*/

export function useScope<T>(values: T): T {
  return Object.assign(useRef({} as T).current, values);
}
